exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.metric-card{height:80px;display:flex;border-radius:8px;overflow:hidden;box-shadow:1px 0 6px 1px rgba(0,0,0,.3)}.metric-card__left-side{width:61%;color:#d8d8d8;background-color:#333}.metric-card__left-side .title{white-space:nowrap;margin:13px 0 0 14px;font-family:Oswald,sans-serif;text-transform:uppercase;font-size:20px;font-weight:400;line-height:24px}.metric-card__left-side .percent-change{font-family:Open Sans,sans-serif;display:flex;align-items:center;margin:5px 0 0 35px}.metric-card__left-side .percent-change__text{font-size:8px}.metric-card__left-side .percent-change__value{display:flex;font-size:16px}.metric-card__left-side .percent-change__value .percent-change-arrow{color:#d8d8d8;display:flex;letter-spacing:-4px;margin-right:4px}.metric-card__left-side .percent-change__value .percent-change-arrow svg{margin-top:4px}.metric-card__right-side{width:40%;display:flex;font-family:Oswald,sans-serif;color:#fff;font-weight:500}.metric-card__right-side .metric-value{font-size:84px;line-height:93px;margin-left:-7px}.metric-card__right-side .percent-symbol{font-size:26px;margin-top:10px}@media only screen and (min-device-width:320px) and (max-device-width:360px){.metric-card__left-side .title{font-size:20px}.metric-card__left-side .percent-change{margin:5px 0 0 20px}}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/DashboardMetricCard/DashboardMetricCard.scss
// module id = 1542
// module chunks = 0